import React, { FC, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import config from '../config';
import { ServerInfo } from '@app/domain/info';
import { fetchAllServersInfo } from '@app/services/serverInfoService';

interface Props {
  className?: string;
}

const Footer: FC<Props> = ({ className }) => {
  const currentYear = new Date().getFullYear();
  const [serversInfo, setServersInfo] = useState<ServerInfo[]>([]);

  useEffect(() => {
    fetchAllServersInfo().then(setServersInfo);
  }, []);

  return (
    <Container className={className}>
      © {currentYear} nsKnox Technologies v{config.version}
      {serversInfo.length > 0 && (
        <ServerInfoList>
          {serversInfo.map((info) => (
            <li key={info.url}>
              <strong>{info.serverName}</strong>:&nbsp;
              <code>{info.branch || 'N/A'}</code>, Time:{' '}
              <code>{info.commitDate ? new Date(info.commitDate).toLocaleString() : 'N/A'}</code>
            </li>
          ))}
        </ServerInfoList>
      )}
    </Container>
  );
};

export default Footer;

const Container = styled.footer`
  padding: 68px 50px 0;
  text-align: center;
  font-size: 13px;
  color: rgba(61, 68, 90, 0.8);
  background-color: transparent;
  font-weight: 200;
`;

const ServerInfoList = styled.ul`
  margin: 10px auto 0;
  padding: 0;
  list-style: none;
  font-size: 12px;
  color: #555;
  max-width: 800px;
  text-align: center;
`;
